<template>
<div id="stat">
  <van-nav-bar
    title="数据统计"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
  <div style="position: relative;overflow: hidden;">
    <van-dropdown-menu>
      <van-dropdown-item v-model="queryForm.reim_status" :options="statusList" @change="changeStatus" />
      <van-dropdown-item v-model="queryForm.brand_id" :options="brands" @change="changeBrand" />
      <van-dropdown-item v-model="queryForm.city_id" :options="cities" @change="changeCity" />
      <div style="position: absolute; right: 20px; top: 10px; width: 80px;" @click="showSearch">
        <van-icon name="filter-o"  />筛选
      </div>
    </van-dropdown-menu>
  </div>
  <div>
    <div class="stat_count">
      <div id="stat_count"></div>
    </div>
    <div class="stat_price">
      <div id="stat_price"></div>
    </div>
    <div class="stat_price">
      <div id="stat_payment"></div>
    </div>
  </div>

  <van-popup v-model:show="show" position="bottom" :style="{ width: '100%', height: '60%' }">
    <div style="text-align: left;padding: 20px;">操作</div>
    <el-form label-position="left" label-width="100px" style="width: 94%; margin: 10px auto;">
      <el-form-item label="商场：" prop="market_id">
        <el-select v-model="queryForm.market_id" :allow-create="true" placeholder="支持输入" filterable class="form-item-width" @change="syncShops">
          <el-option v-for="(v, k) in marketList" :key="k" :value="v.id" :label="v.market_cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="店铺：" prop="store_id">
        <el-select v-model="queryForm.store_id" placeholder="请选择" filterable class="form-item-width">
          <el-option v-for="v in storeList" :key="v.id" :value="v.id" :label="v.name_cn" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建年份：" prop="store_id">
        <el-select v-model="queryForm.reim_create_at_year" placeholder="请选择" filterable class="form-item-width">
          <el-option v-for="v in years" :key="v" :value="v" :label="v" />
        </el-select>
      </el-form-item>
      <el-form-item label="完工年份：" prop="store_id">
        <el-select v-model="queryForm.completed_at_year" placeholder="请选择" filterable class="form-item-width">
          <el-option v-for="v in years" :key="v" :value="v" :label="v" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="default" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
  </van-popup>
</div>
</template>

<script>
import {getBrandList, getCityList, getMarketList, getShopList} from "../../api/order";
import {getReimAllStatusList, getReimCountChars} from "../../api/reimbursement";
import * as echarts from "echarts";

export default {
  name: "stat",
  data() {
    return {
      brands: [],
      cities: [],
      markets: [],
      storeList: [],
      marketList: [],
      statusList: [],
      years: [2021, 2022, 2023],
      queryForm: {
        create_date: [],
        select_date: [],
        states: [],
        brandIds: [],
        applyDate: [],
        completeDate: [],
        code: '',
        city_id: '',
        market_id: '',
        brand_id: '',
        reim_status: '',
        pre_quote_status: 0
      },
      show: false
    }
  },
  created() {
    this.getBrandList()
    this.getCityList()
    this.getStatusList()
    this.queryList()
  },
  methods: {
    getStatusList() {
      getReimAllStatusList().then((res) => {
        if (res.data.data) {
          for (const item in res.data.data) {
            this.statusList.push({
              text: res.data.data[item].v === '全部' ? '所有状态' : res.data.data[item].v,
              value: res.data.data[item].k
            })
          }
        }
      })
    },
    onSubmit() {
      this.show = false
      this.queryList()
    },
    syncShops() {
      this.searchStore()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
    },
    async changeStatus() {
      await this.queryList()
    },
    async changeBrand(val) {
      this.searchStore()
      await this.queryList()
    },
    changeMarket(val) {
      this.searchStore()
    },
    getBrandList() {
      getBrandList().then((res) => {
        if (res.data.data) {
          this.brands = [{
            text: '所有品牌',
            value: ''
          }]
          for (const i in res.data.data) {
            this.brands.push({
              text: res.data.data[i].brand_en,
              value: res.data.data[i].id
            })
          }
        }
      })
    },
    getCityList() {
      getCityList().then((res) => {
        if (res.data.data) {
          this.cities = [{
            text: '所有城市',
            value: ''
          }]
          for (const i in res.data.data) {
            this.cities.push({
              text: res.data.data[i].city_cn,
              value: res.data.data[i].id
            })
          }
        }
      })
    },
    marketLists(cityId) {
      getMarketList({city_id: cityId}).then((res) => {
        if (res.data.data) {
          this.marketList = res.data.data
        }
      })
    },
    searchStore() {
      getShopList(this.queryForm).then((res) => {
        if (res.data.data) {
          this.storeList = res.data.data
        }
      })
    },
    showSearch() {
      this.show = true
      this.getBrandList()
      this.marketLists(this.queryForm.city_id)
      this.searchStore()
    },
    changeCity(val) {
      this.searchStore()
      this.queryList()
    },
    initCount(queryData) {
      queryData.count_chars_type = 'reim_count'
      getReimCountChars(queryData).then((res) => {
        console.log('res............', res)
        const months = []
        const counts = []
        for (const item in res.data.data) {
          months.push(res.data.data[item].month)
          counts.push(res.data.data[item].cnt)
        }
        const totalReport = document.getElementById("stat_count");
        if (totalReport === null) {
          return false;
        }
        const myChart = echarts.init(totalReport);
        const option = {
          title: {
            text: "维修次数",
          },
          xAxis: {
            type: "category",
            data: months,
            axisLabel: {
              interval: 0,
              rotate: 45,
            }
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: counts,
              type: "bar",
            },
          ],
        };
        console.log("option........", option)
        option && myChart.setOption(option);
      })
    },
    initPrice(queryData) {
      queryData.count_chars_type = 'reim_price'
      getReimCountChars(queryData).then((res) => {
        const months = []
        const counts = []
        for (const item in res.data.data) {
          months.push(res.data.data[item].month)
          counts.push(res.data.data[item].cnt)
        }
        const totalReport = document.getElementById("stat_price");
        if (totalReport === null) {
          return false;
        }
        const myChart = echarts.init(totalReport);
        const option = {
          title: {
            text: "报销金额",
          },
          xAxis: {
            type: "category",
            data: months,
            axisLabel: {
              interval: 0,
              rotate: 45,
            }
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: counts,
              type: "line",
              itemStyle: { normal: {label: {show: true}} }
            },
          ],
        };
        console.log("option........", option)
        option && myChart.setOption(option);
      })
    },
    initPayment(queryData) {
      queryData.count_chars_type = 'reim_payment'
      getReimCountChars(queryData).then((res) => {
        const months = []
        const counts = []
        for (const item in res.data.data) {
          months.push(res.data.data[item].month)
          counts.push(res.data.data[item].cnt)
        }
        const totalReport = document.getElementById("stat_payment");
        if (totalReport === null) {
          return false;
        }
        const myChart = echarts.init(totalReport);
        const option = {
          title: {
            text: "打款金额",
          },
          xAxis: {
            type: "category",
            data: months,
            axisLabel: {
              interval: 0,
              rotate: 45,
            }
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: counts,
              type: "line",
              itemStyle: { normal: {label: {show: true}} }
            },
          ],
        };
        option && myChart.setOption(option);
      })
    },
    queryList() {
      const queryData = this.queryForm
      this.initCount(queryData)
      this.initPrice(queryData)
      this.initPayment(queryData)
    }
  }
}
</script>

<style>
#stat .van-card__content {
  text-align: left;
}
#stat .van-dropdown-menu__bar {
  width: 70% !important;
  padding-right: 40% !important;
}
.el-select-dropdown el-popper {
  z-index: 99999;
}
</style>
<style scoped>
.stat_count, .stat_price {
  width: 98%;
  margin: 0 1%;
  background-color: #c9c9c9;
  border-radius: 1vw;
}
#stat_count, #stat_price {
  width: 100%;
  height: 36vh;
  margin-bottom: 1vh;
}
</style>



// WEBPACK FOOTER //
// src/views/stat/stat.vue